/*eslint-disable*/
import { BodyText } from 'styling/Typography'
import { Input } from '../../../components/Input/Input'
import { Animation, Button, ButtonsContainer, Flex, ItemsGrid, TabFooter } from '../../../styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { IItemsTab } from 'types/inventory.interface'
import { DropZone } from 'components/DropZone/DropZone'

export const InventoryItemsStorageTab = ({
  file,
  state,
  setFile,
  setState,
  setActive,
}: IItemsTab) => {

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setState((prev) => ({ ...prev, [name]: value }))
  }

  const handleNext = () => {
    setActive('Tracking')
  }

  return (
    <Animation>
      <Flex column width='100%' >
        <ItemsGrid columns={3} gap='1rem'>
          <Input
            value={state?.hazardClass}
            name='hazardClass'
            onChange={handleChange}
            placeholder='Enter class'
            labelText='Hazard Class'
          />

          <Flex column  >
            <BodyText>MSDS Attachment</BodyText>
            <DropZone acceptAll file={file} setFile={setFile} />
          </Flex>
        </ItemsGrid>

      </Flex>

      <TabFooter >
        <ButtonsContainer>
          <CancelBtn />
          <Button orange onClick={handleNext}>
            Next
          </Button>
        </ButtonsContainer>
      </TabFooter>
    </Animation>
  )
}
